export default /* @ngInject */ ($q, $http) => new CountriesUtilService($q, $http);

class CountriesUtilService {
	
	constructor($q, $http) {
		this.$q = $q;
		this.$http = $http;

		this.countries = [];
		//this.load();
	}

	load() {
		const deferred = this.$q.defer();
		const promise = deferred.promise;
		const url = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
			? ''
			: '/'}Scripts/app/services/common/countries/countries.json`;

		this.$http.get(url).then(
			(results) => {
				this.countries = this.map(results.data);
				deferred.resolve(results.data);
			},
			(err) => {
				const msg = `Error while loading 'countries.json'`;
				console.error(msg, err);
				deferred.reject(msg);
			}
		);

		return promise;
	}

	map(countryList) {
		let mappedList = [];

		countryList.forEach((country) => {
			const mapped = {
				country: country.country,
				countryCode: country['country-code']
			};

			mappedList.push(mapped);
		});

		return mappedList;
	}
}

/*

    serviceModule.factory('CountriesUtilService', CountriesUtilServiceInstance);
})(angular.module("pretor.online.factories"));
*/
